import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';
import { BaseWebService } from "../../shared/services/base-web.service";
import 'rxjs/add/observable/throw';



@Injectable()
export class ResetPasswordService {

    constructor(
        private _baseWebService: BaseWebService
    ) { }
    

    /**
     * Service for get reset password
     */
    resetPassword(value: any) {
         const data: any = {};
        data.body = value;
        return this._baseWebService.requestWithoutToken("v1/recover_password/", "put", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Service for validating token
     */
    ValidateToken(token: any) {
        return this._baseWebService.requestWithoutToken("v1/recover_password/?token=" + token, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /* Service for handling service call errors
     * @param  {Response|any} error contains error data
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }



}

